module.exports = __webpack_public_path__ + "static/media/Poppins-ExtraLight.dc8473da.woff";